import { isEmpty } from 'lodash-es';
import CardValidator from 'card-validator';
import Cleave from 'cleave.js';
import _ from 'lodash';

export default class CreditCardFormValidation {
  constructor(form, callbacks) {
    this.$scope = form;
    this.callbacks = callbacks || {};

    this.isValid = false;
    this.$holderName = this.$scope.querySelector('[data-validation="holder-name"]');
    this.$cardNumber = this.$scope.querySelector('[data-validation="credit-card-number"]');
    this.$cardExpiration = this.$scope.querySelector('[data-validation="expiration"]');
    this.$cvv = this.$scope.querySelector('[data-validation="cvv"]');
    this.$paymentCompanyCode = this.$scope.querySelector('input#payment-company-code')

    this.cardNumberEvents();
    this.cardExpirationEvents();
    this.watchValidations();
  }

  emit(event, data = {}) {
    (this.callbacks[event] || (() => {}))(data);
  }

  cardNumberEvents() {
    return new Cleave(this.$cardNumber, {
      creditCard: true,
      onValueChanged: () => {
        let creditCard = CardValidator.number(this.$cardNumber.value);
        this.emit('onCardNumberChange', creditCard);
        // this.emit('onCardTypeChanged', { type: null, card: creditCard });

        if (!creditCard.isValid)
          return;

        this.$paymentCompanyCode.value = creditCard.card.niceType.toLowerCase().replace(/\s/ig, '_');
      },
      onCreditCardTypeChanged: (type) => {
        console.log('onCreditCardTypeChanged')
        this.emit('onCardTypeChanged', { type: type, card: CardValidator.number(this.$cardNumber.value) });
      }
    });
  }

  cardExpirationEvents() {
    return new Cleave(this.$cardExpiration, {
      date: true,
      datePattern: ['m', 'y']
    });
  }

  watchValidations() {
    this.validations().forEach((validation) => {
      validation.el.addEventListener('keyup', () => this.validate());
    });
  }

  validate() {
    let valid = true;

    this.validations().forEach((validation) => {
      let elValid = validation.isValid(validation.el),
        formGroup = validation.el.closest('.form-group');

      valid &= elValid;
      formGroup.classList.remove('success', 'has-error');
      elValid ? formGroup.classList.add('success') : formGroup.classList.add('has-error');
    });

    this.isValid = valid;
    this.emit('afterValidate', valid);

    return valid;
  }

  validations() {
    return [{
      el: this.$holderName,
      isValid: (el) => !isEmpty(el.value) && el.value.length > 3
    }, {
      el: this.$cardNumber,
      isValid: (el) => CardValidator.number(el.value).isValid
    }, {
      el: this.$cardExpiration,
      isValid: (el) => /^[0-9]{2}\/[0-9]{2}$/ig.test(el.value)
    }, {
      el: this.$cvv,
      isValid: (el) => /^[0-9]{3,4}$/ig.test(el.value)
    }]
  }
}